export const requisites = {
    inn: '181703161790',
}

export const contacts = {
    base_phone: '74999389929',
    info_mail: 'x.devs@yandex.ru',
    address: 'Москва, пос. Совхоза имени Ленина, 17 корпус 2',
}
